
import React, { useEffect, useRef } from 'react'
import useState from 'react-usestateref'

import styles from './form.module.sass'

import each from 'lodash/each'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'

function Form(props) {
	const [form, setForm] = useState(null)
	const [submitted, setSubmitted] = useState(false)
	const formWrapperRef = useRef(null)
	const formId = props.fields.id || 1

	useEffect(() => {

		async function fetchData() {
			const response = await fetch(`/wp-json/3fo-base/v1/form/${formId}`, {
				cache: 'no-cache',
				headers: {
					'Content-Type': 'application/json'
				},
			})

			const responseJson = await response.json()
			setForm(responseJson)
		}

		fetchData()
	}, [])

	function clearErrors() {
		const errors = [...formWrapperRef.current.querySelectorAll(`.${styles.error}`)]
		errors.map((error) => {
			error.remove()
		})
	}

	function populateErrors(errorData) {
		each(errorData, (value, fieldId) => {
			const error = document.createElement('p')
			error.classList.add(styles.error, 'error')
			error.textContent = value
			formWrapperRef.current.querySelector(`[name="input_${fieldId}"]`).parentNode.appendChild(error)
		})
	}

	useEffect(() => {
		if (form) {
			const formElement = formWrapperRef.current.querySelector('form')
			if (formElement) {
				// setTimeout(() => {
				// 	formElement.querySelector('[name="input_1"]').value = 'Joren'
				// 	formElement.querySelector('[name="input_3"]').value = 'Mathews'
				// 	formElement.querySelector('[name="input_4"]').value = 'joren@300feetout.com'
				// 	formElement.querySelector('[name="input_5"]').value = '3fo'
				// 	formElement.querySelector('[name="input_6"]').value = 'Lorem ipsum'
				// }, 1000)
				formElement.addEventListener('submit', async (e) => {
					e.preventDefault()

					clearErrors()

					let body = new FormData(formElement)
					body = Object.fromEntries(body)
					const response = await fetch(`/wp-json/3fo-base/v1/form/${formId}`, {
						method: 'POST',
						body: JSON.stringify(body),
						headers: {
							'Content-Type': 'application/json'
						},
					})

					const responseJson = await response.json()
					
					window.scrollTo({top: 0, behavior: 'smooth'})

					if (responseJson.success == true) {
						window.dataLayer = window.dataLayer || []
						window.dataLayer.push({
							'event':'ec_formsubmit',
							'enhanced_conversion_data': {
								"email": body.input_4,
							}
						})

						if (responseJson.message) {
							setSubmitted(responseJson.message)
						} else if (responseJson.redirect) {
							window.location = responseJson.redirect
						}
					} else {
						populateErrors(responseJson.validation_messages)
					}
				})
			}

			if(formId == 1 && typeof gf_apply_rules !== 'undefined') {
				let rulesApplied = false
				
				setTimeout(() => {
					if (rulesApplied) return
					
					if (typeof gf_form_conditional_logic !== 'undefined' && gf_form_conditional_logic[1]) {
						rulesApplied = true
						gf_apply_rules(1, [10,12,13,14,15,16,17,7], true)
					} else {
						setTimeout(() => {
							if (!rulesApplied && typeof gf_form_conditional_logic !== 'undefined' && gf_form_conditional_logic[1]) {
								rulesApplied = true
								gf_apply_rules(1, [10,12,13,14,15,16,17,7], true)
							}
						}, 200)
					}
				}, 500)
			}
		}
	}, [form])

	return <BlockWrapper {...props}>
		<ScrollAnimation styles={styles}>
			{submitted && <div dangerouslySetInnerHTML={{__html: submitted}}></div>}
			{!submitted && <div ref={formWrapperRef} className={styles.form} dangerouslySetInnerHTML={{__html: form}}></div>}
		</ScrollAnimation>
	</BlockWrapper>
}

export default Form